import { render, staticRenderFns } from "./salaryImport.vue?vue&type=template&id=2308a6de"
import script from "./salaryImport.vue?vue&type=script&lang=js"
export * from "./salaryImport.vue?vue&type=script&lang=js"
import style0 from "./salaryImport.vue?vue&type=style&index=0&id=2308a6de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports